// src/utils/permission.js
export function hasAccess(user, permission = {}) {
  const { user_level: lvl, dept = [] } = user;
  const { minLevel, exactLevels, requiredDepts, orMinLevel, orDev, insightSupport } = permission;

  // Insight Console: dev/Support เท่านั้น (server ตรวจซ้ำทุก endpoint)
  if (insightSupport) {
    return Boolean(user.is_insight_support);
  }

  // OR-condition: dev (DEV_USER_CODES) เข้าได้เพื่อทดสอบ — API ยังตรวจสิทธิ์ของตัวเองซ้ำทุกครั้ง
  if (orDev && user.is_dev) {
    return true;
  }
  if (orMinLevel !== undefined && lvl >= orMinLevel) {
    return true;
  }
  // exactLevels (override minLevel)
  if (Array.isArray(exactLevels)) {
    return exactLevels.includes(lvl);
  }
  // minLevel
  if (minLevel !== undefined && lvl < minLevel) {
    return false;
  }
  // requiredDepts
  if (Array.isArray(requiredDepts)) {
    return requiredDepts.some(d => dept.includes(d));
  }
  // default: ผ่าน
  return true;
}